// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2em80","legacyBtn":"MutateMid_legacyBtn__3i-mT"};